import { useMemo, useState } from "react";
import { emptySlots, filledOrder, placeTile, remainingTiles, removeSlot } from "../../domain/mechanics";
import { speakEnglish } from "./audio";
import { SceneCard } from "./SceneCard";
import type { PlayItem } from "./types";

function sceneWord(prompt: string): string {
  const hit = ["Mia", "Ben", "Pip", "cat", "bag", "box", "key", "book", "map", "kite", "ball"].find((w) => prompt.includes(w));
  return (hit || "mia").toLowerCase();
}

export function PhrasePlayer({ item, onSubmit }: { item: PlayItem; onSubmit: (selected: unknown) => void }) {
  const tiles = item.tiles ?? [];
  const isBuild = item.type === "BUILD" && tiles.length > 0;
  const slotCount = item.slotCount ?? (isBuild ? tiles.length : 0);
  const [slots, setSlots] = useState<Array<string | null>>(() => emptySlots(Math.max(slotCount, 0)));
  const [picked, setPicked] = useState<string | null>(null);
  const bank = useMemo(() => remainingTiles(tiles, slots), [tiles, slots]);

  if (isBuild) {
    const order = filledOrder(slots);
    return (
      <div>
        <SceneCard word={sceneWord(item.prompt)} />
        <p>Собери реплику по слотам. Нажми плитку, затем «Снять кадр».</p>
        <div className="slots" role="list">
          {slots.map((slot, i) => (
            <button
              key={`${slot ?? "empty"}-${i}`}
              type="button"
              className={`slot${slot ? " filled" : ""}`}
              onClick={() => setSlots(removeSlot(slots, i))}
            >
              {slot ?? "•"}
            </button>
          ))}
        </div>
        <div className="tools tiles">
          {bank.map((tile, i) => (
            <button
              key={`${tile}-${i}`}
              type="button"
              className="btn ghost tile"
              onClick={() => setSlots(placeTile(slots, tile))}
            >
              {tile}
            </button>
          ))}
        </div>
        <button type="button" className="btn" disabled={!order} onClick={() => order && onSubmit(order)}>Снять кадр</button>
      </div>
    );
  }

  const options = item.options ?? tiles;
  return (
    <div>
      <div className="tools">
        <button type="button" className="btn ghost" onClick={() => speakEnglish(item.prompt)}>Послушать реплику</button>
      </div>
      <SceneCard word={sceneWord(item.prompt)} />
      <div className="tools">
        {options.map((opt) => (
          <button key={opt} type="button" className={`btn${picked === opt ? " steel" : ""}`} onClick={() => setPicked(opt)}>
            {opt}
          </button>
        ))}
      </div>
      <button type="button" className="btn" disabled={!picked} onClick={() => onSubmit(picked)}>Снять кадр</button>
    </div>
  );
}
